import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { formatFileSize, getENV } from 'src/app/_helpers/helpers';
import { APIService } from 'src/app/services/api.service';
import { FileUploadService } from 'src/app/services/fileupload.service';

@Component({
  selector: 'race-reports-lps-generate-report',
  templateUrl: './lps-generate-report.component.html',
  styleUrls: ['./lps-generate-report.component.css'],
})
export class LpsGenerateReportComponent implements OnInit {
  @Input({ required: true }) lps: any;
  @Input({ required: true }) config: any;

  formatFileSize: any = formatFileSize;

  constructor(
    private apiService: APIService,
    private fileUploadService: FileUploadService
  ) {}

  files: string[] = [];
  ngOnInit(): void {
    if (!this.lps.reportType) {
      this.lps.reportType = '';
    }
    if (!this.lps.sourceType) {
      this.lps.sourceType = '';
    }
    this.loadXMLs();
  }

  dragging: boolean = false;
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragging = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragging = false;
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.dragging = false;

    if (!event.dataTransfer.types.includes('Files')) {
      this.lps.fileError = 'Not a valid file';
      return;
    }

    this.validateFile(event.dataTransfer.files);
  }

  validateFile(files: FileList): boolean {
    this.lps.fileError = null;
    if (files && files.length == 0) {
      this.lps.fileError = 'Missing file';
      return false;
    } else if (files.length > 1) {
      this.lps.fileError = 'Multiple files are not allowed';
      return false;
    } else if (!files[0].name.toLowerCase().endsWith('.xml')) {
      this.lps.fileError = 'Only XML file is allowed';
      return false;
    }
    this.lps.fileError = '';
    this.lps.file = files[0];
    // this.lps.uploadStatus = 'COMPLETED';
    return true;
  }

  onFileSelected(event: Event) {
    const element = event.target as HTMLInputElement;
    const files = element.files;
    let status: boolean = this.validateFile(files);
    if (!status) {
      element.value = '';
    }
  }

  cancelPDF() {
    this.lps.uploadStatus = null;
    this.lps.file = null;
  }

  async loadXMLs() {
    this.lps.loadingXMLs = true;
    this.lps.sourceType = '';
    let apiURL: string = `${this.config[getENV()].raceAPI}/flask-operations`;

    let payload: any = {
      action: 'get_tol_files_list',
      location: this.lps.raceCource.venue_name,
      event_id: this.lps.raceCource.external_event_id,
      race_number: this.lps.race.SquentialRaceOrderNumber,
      race_date: this.lps.raceCource.date,
      jurisdiction: this.lps.raceCource.JurisdictionCode,
      type: this.lps.raceCource.RaceType,
    };

    let result: any = await this.apiService.postDataPromis(apiURL, payload, {});

    if (result.status == '1' || result.s == '1') {
      this.files = result.files;
    } else {
      this.files = [];
    }

    this.lps.loadingXMLs = false;
  }

  async handleFile() {
    // Process the file here (e.g., upload to server, parse XML, etc.)
    this.lps.uploadStatus = 'GETTING_PRESIGNED_URL';
    let apiURL: string = `${this.config[getENV()].raceAPI}/flask-operations`;

    let payload: any = {
      action: 'upload_lps_xml_to_s3',
      file_name: this.lps.file.name,
      location: this.lps.raceCource.venue_name,
      event_id: this.lps.raceCource.external_event_id,
      race_number: this.lps.race.SquentialRaceOrderNumber,
      race_date: this.lps.raceCource.date,
      jurisdiction: this.lps.raceCource.JurisdictionCode,
      type: this.lps.raceCource.RaceType,
    };

    let result: any = await this.apiService.postDataPromis(apiURL, payload, {});

    if (result.status == '1' || result.s == '1') {
      this.lps.uploadStatus = 'PRESIGNED_URL_GENERATED';
      this.lps.presigned_url = result.response;
      this.uploadFile(this.lps.file, result);
    } else {
      this.lps.uploadStatus = null;
      this.lps.fileError =
        result.error_message || 'Failed to Upload File. Please try again';
    }
  }

  async uploadFile(file: File, result: any) {
    await this.uploadFileAPI(result, file);
  }

  async uploadFileAPI(result: any, file: any) {
    return new Promise(async (resolve: any, reject: any) => {
      this.fileUploadService
        .uploadFile(result.url, file)
        .subscribe(async (event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.Sent:
              break;
            case HttpEventType.ResponseHeader:
              break;
            case HttpEventType.UploadProgress:
              this.lps.uploadStatus = 'UPLOADING';
              let progress = Math.round(
                (event.loaded / (event.total || 0)) * 100
              );
              this.lps.uploaded = event.loaded;
              this.lps.percentage = progress;
              break;
            case HttpEventType.Response:
              if (event.status === 200) {
                this.lps.uploadStatus = 'UPLOADED';
                this.tolProcessor(result);
                resolve(true);
              } else {
                this.lps.uploadStatus = 'ERROR';
                this.lps.fileError = `Upload failed with status ${event.status}`;
                reject(new Error(`Upload failed with status ${event.status}`));
              }
              break;
            case HttpEventType.User:
              break;
          }
        });
    });
  }

  async tolProcessor(result: any) {
    this.lps.uploadStatus = 'PROCESSING';
    let apiURL: string = `${this.config[getENV()].raceAPI}/flask-operations`;
    const bucketNameRegex = /https:\/\/([^.]+)\.s3\.amazonaws\.com/;
    const match = result.url.match(bucketNameRegex);
    let bucketName: string;
    if (match && match[1]) {
      bucketName = match[1];
    }

    let payload: any = {
      action: 'trigger_rnsw_tol_processor',
      location: this.lps.raceCource.venue_name,
      event_id: this.lps.raceCource.external_event_id,
      race_number: this.lps.race.SquentialRaceOrderNumber,
      race_date: this.lps.raceCource.date,
      jurisdiction: this.lps.raceCource.JurisdictionCode,
      type: this.lps.raceCource.RaceType,
      bucket: bucketName,
      key: result.s3_prefix + '/' + this.lps.file.name,
      file_name: this.lps.file.name,
    };
    let response: any = await this.apiService.postDataPromis(
      apiURL,
      payload,
      {}
    );

    if (
      (response.s == '1' || response.status == '1') &&
      response.response.statusCode == 200
    ) {
      this.lps.fileSuccess = 'File Uploaded and Processed Successfully';
    } else {
      this.lps.fileError =
        response.error_message ||
        response.response.body ||
        'Failed to Process File. Please try again';
    }
    this.loadXMLs();
    this.lps.uploadStatus = 'COMPLETED';
  }

  viewContent() {
    const reader = new FileReader();
    reader.onload = (e) => {
      this.previewXML(e.target.result);
    };
    reader.readAsText(this.lps.file);
  }

  previewXML(xmlContent) {
    // Create a new window
    const newWindow = window.open('', '_blank');

    // Create a pre element to preserve formatting
    const preElement = newWindow.document.createElement('pre');

    // Format the XML content
    const formattedXML = this.formatXML(xmlContent);

    // Set the formatted XML as the text content of the pre element
    preElement.textContent = formattedXML;

    // Append the pre element to the new window's body
    newWindow.document.body.appendChild(preElement);

    // Add some basic styling
    newWindow.document.head.innerHTML = `
      <style>
          body { font-family: monospace; background-color: #f0f0f0; }
          pre { white-space: pre-wrap; word-wrap: break-word; }
      </style>
  `;
  }

  formatXML(xml) {
    let formatted = '';
    let indent = '';
    const tab = '  '; // 2 spaces for indentation

    xml.split(/>\s*</).forEach(function (node) {
      if (node.match(/^\/\w/)) {
        indent = indent.substring(tab.length); // Decrease indent
      }
      formatted += indent + '<' + node + '>\r\n';
      if (node.match(/^<?\w[^>]*[^\/]$/)) {
        indent += tab; // Increase indent
      }
    });

    return formatted.substring(1, formatted.length - 3);
  }
}
